// Banque d'avatars joueurs hébergée par la console (public/avatars/adventurer/).
// Partagée entre l'app (sampleAvatar) et scripts/generate-avatars.mjs.
// Changer AVATAR_COUNT = relancer le script avant de déployer.

export const AVATAR_COUNT = 2000;

export const avatarFileName = (index: number) => `${String(index).padStart(4, '0')}.png`;

// Hôte FIXE : l'URL est enregistrée (Firestore, highscores) et affichée par
// l'écran et les jeux. Avec l'origine de la page, un avatar tiré sur un canal de
// prévisualisation (expire en 7 j) ou en local resterait cassé pour toujours.
export const AVATAR_HOST = 'https://console.unboared.com';

/** URL absolue d'un avatar de la banque (servi par Firebase Hosting avec la console). */
export const avatarURL = (index: number) => `${AVATAR_HOST}/avatars/adventurer/${avatarFileName(index)}`;
